import { IFilterListWithoutPagination } from "../../utils/interfaces/FilterListInterface";
import { toQueryString } from "../../utils/parsers/QueryString";

export class SellerAccountStatementListFilterFormModel implements IFilterListWithoutPagination {
    dateStart: Date|null = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
    dateEnd: Date|null = new Date()

    isFilterFilled():boolean {
        return !!this.dateStart && !!this.dateEnd
    }

    toQueryString():string {
        const tmp = {
            ...this,
            dateStart: this.dateStart?.toISOString(),
            dateEnd: this.dateEnd?.toISOString(),
        }

        return toQueryString(tmp)
    }
}
